import styled from 'styled-components/macro';
export const QrCodeWrapperStyled = styled.div `
  align-self: center;
  padding: 32px;
`;
